export default __webpack_public_path__ + "static/media/insight-logo.35b58b06.svg";